import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { makeStyles } from "@material-ui/core"
import { Switch, Route, useHistory, Redirect } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';

// ---------------- CSS ----------------

import './resources/css/display_wallet.css'
import './resources/css/display_wallet_functions.css'
import './resources/css/badges.css'

// TODO get inspiration from tokkenr client to remove those
// import './resources/css/bootstrap_tables_onlycss.css'
// import './resources/css/bootstrap-alert.css'
import './resources/css/bootstrap-progressbar.css'

// ---------------- JS ----------------

// on charge les fonctions qui rendent l'interface dynamique
import { UserContext } from "./Contexts/UserContext/UserContext.js"
import SwapBotContext from './Contexts/SwapBotContext.js';
import { translateErrorToJSXMessage, isNetworkErrorString } from "./translateErrorToJSXMessage.js"
import { route_wallet_unlock } from "./App.js"
// import init_wallet_interactions from './display_wallet_interactions.js'
// import { TokenContract, MultList, Blacklist, RevokerContract } from "./myjigs/TokenContract.js" // BEWARE IF YOU ADD ANYTHING HERE GO ALSO SEE THIS LINE : search "ZEHGUIZGL54546"
// import { onlyResolvesLast } from 'awesome-only-resolves-last-promise';

// import slides to display => TODO: delete those not used anymore
import Slide_Send from "./pages/Slide_Send/Slide_Send.js"
import Slide_Settings from "./pages/Slide_Settings.js"
import Slide_PublishMultiplicator from "./pages/Slide_PublishMultiplicator.js"
import Slide_GlobalBurn from "./pages/Slide_GlobalBurn.js"
import Slide_WalletHome from "./pages/Slide_WalletHome.js"
import Slide_Balance from "./pages/Slide_Balance.js"
import Slide_Multiplicators from "./pages/Slide_Multiplicators.js"
import Slide_History from "./pages/Slide_History/Slide_History.js"
import Slide_MintTokens from "./pages/Slide_MintTokens.js"
import Slide_ReportBug from "./pages/Slide_ReportBug.js"
import Slide_AllRevoke from "./pages/Revoke/Slide_AllRevoke.js"
import Slide_TokkenR from "./pages/ContratTokkenR/Slide_TokkenR.js"
import Slide_Burn from "./pages/Slide_BurnBlacklist/Slide_Burn.js"
import {
	Slide_EchangeTokens_QR, Slide_EchangeTokens_SwapBot
} from "./pages/EchangeTokens/Slide_EchangeTokens.js"
import { Slide_SwapBot } from "./pages/SwapBot/Slide_SwapBot.js"

// other components
import MenuPanelOptions from './components/MenuPanel/MenuPanelOptions.tsx';

import { FormattedNumber } from './components/FormattedNumber'
import { Loader } from './components/Loader'
import { WithPopup } from './components/WithPopup/TextCopyQR'
import Indent from './components/Indent'
import GlobalErrorContext from './Contexts/GlobalErrorContext'
import useLog from './hooks/useLog'
import { SyncBlockchainPopup } from './pages/SyncBlockchainPopup.js'
import { getLog } from './helpers/helpers'
import { toFixedDown } from './helpers/convert_bsv_tokens'
import { useTokenOrigin } from './helpers/useTokenOrigin.js'
import Constants, { appConfig } from './config.js'
import { ButtonPrimary } from './components/Buttons.js'
import TokkenR_logo from './components/TokkenR_logo.js';



// --------- MANUAL VARS ----------------

export const TRANSACTIONS_PAGE_LIMIT = 7

export var CLIENT_MODE = true

export const ACTIVATE_SWAPSADMIN = true  // TODO virer une fois validé que les swaps marchent


const log = (...args) => { console.log("display_wallet.js:", ...args) }

// turn off client mode if we are compiling as admin version
// note window.electron.appname seems to not exist in dev mode
let _appname = ""
const is_dev_server = !!!window.electron
log("is_dev_server:", is_dev_server)
if (!is_dev_server) {
	_appname = window.electron.appname
}
if (!_appname || _appname.length == 0) {
	_appname = Constants.APP_NAME
}
const appname = _appname.toLowerCase()
log("appname = ", appname)
if (appname && appname.includes("admin") && !appname.includes("client")) {
	CLIENT_MODE = false
}
// here you can choose which version to display in dev mode (but with electron)
if (appname.toLowerCase() === "electron") {
	CLIENT_MODE = true
}
else if (!appname) {  // in dev mode with webpack-dev-server
	CLIENT_MODE = true
}
log("CLIENT_MODE:", CLIENT_MODE)


/**	props:
	- num - a unique number for identification in html DOM
	- children - jsx elements to display in slide
	- (optionnel) dontaddspacebelow: will prevent adding the usual space below
*/
export function Slide(props) {
	var spacebelow = <Fragment><br /><br /><br /><br /></Fragment>

	/* on filtre les props supplémentaires propres à ce HOC
	 qui ne devraient pas être transmises au composant wrapped */
	const { dontaddspacebelow, ...passThroughProps } = props;

	let backgroundColor = appConfig.theme.backgroundColorDarker1

	return (
		<div id={"content_tab_" + props.num}
			{...passThroughProps}
			className="tabcontent"
			style={{ backgroundColor: backgroundColor }}
		>
			<div style={{maxWidth: "800px", width: "100%", margin: "0 auto"}}>
				{props.children}
			</div>

			{/* TokkenR logo positioned below all Slide elements */}
			<div style={{
				display: "flex",
				justifyContent: "center",
				position: "relative",
				marginTop: "60px"
			}}>
				<TokkenR_logo width="10em" opacity={0.4} />
			</div>

			{/* let's add some bottom space */}
			{props.dontaddspacebelow ? "" : spacebelow}
		</div >
	)
}

const DetectConvertTokens = (props) => {
	const function_id = "DetectConvertTokens: "
	const classname = function_id
	const log = useLog(function_id)

	const userContext = useContext(UserContext)

	const [displayed_revoke, set_displayed_revoke] = useState(false)
	const [revoke_error, set_revoke_error] = useState(null)

	// note: userContext.revokedetected turns true when needed then false once over
	log("\n userContext.revokedetected:", userContext.revokedetected,
		"\n userContext.revokedetected_error:", userContext.revokedetected_error,
		"\n displayed_revoke:", displayed_revoke,
	)

	// Handle revoke detection and state updates
	useEffect(() => {
		if (userContext.revokedetected && !displayed_revoke){
			set_displayed_revoke(true) // leave time to display success message
		}
	}, [userContext.revokedetected])

	useEffect(() => {
		if (userContext.revokedetected_error && revoke_error !== userContext.revokedetected_error) {
			set_revoke_error(userContext.revokedetected_error)
		}
	}, [userContext.revokedetected_error])

	if (displayed_revoke) {
		// calculate the bsv value in euros if possible
		let soldeeur = null
		const bsvprice = userContext.bsvprice
		const bsvbalance = userContext.balance_bsv
		log("bsvprice:", bsvprice, "\n bsvbalance:", bsvbalance)
		if (bsvbalance && bsvprice) {
			// 1e8 = 10^8, beware 10e8 != 10^8
			soldeeur = parseFloat(bsvbalance / 1e8 * bsvprice)
			soldeeur = toFixedDown(soldeeur, 2)
		}

		let jsx_soldebsv = <>
			{soldeeur ? <>
				<Indent /><FormattedNumber value={soldeeur} decimals="2" separator=" " />€
			</> : null}
			<Indent />&nbsp;
			(<FormattedNumber value={bsvbalance} decimals="0" separator=" " />
			&nbsp;satoshis)
		</>

		// if conversion is over, display button to continue
		let continue_jsx = <><br />
			Conversion terminée avec succès.<br /><br />
			<ButtonPrimary onClick={() => { set_displayed_revoke(false) }}>
				Continue
			</ButtonPrimary>
		</>

		return (
			<div style={{ height: "4096px" }}>
				<center>
					<div style={{ width: "68%", margin: "20px" }}>
						L'application a détecté que certains de vos tokens doivent être convertis dans une version plus récente.
						<br /><br />
						Veuillez patenter, ce processus est automatique.
						Il va prendre quelques secondes et consommer quelques centimes de BitcoinSV (BSV).
						<br /><br /><br />

						<div style={{ border: "1px solid white", padding: "7px" }}>
							BSV balance:   {jsx_soldebsv} <br /><br />
							BSV address: {userContext.address_purse} <br />
						</div><br /><br />

						{revoke_error ? <>
							Erreur rencontrée:<br /><br />
							{revoke_error}<br /><br />
						</> : null}

						{userContext.revokedetected ? <>
							<br /><Loader text="Conversion en cours..." />
						</> : continue_jsx}
					</div><br />
				</center>
			</div>
		)
	}
	return null  // no converting need detected
}



/**
 * this is needed to pass the multiple higher contexts as props to the Display_Wallet (which becomes "_inner")
 * 
 * props:
 * 		- logpath
 */
const Display_Wallet = (props) => {
	const function_id = "Display_Wallet: "
	const classname = function_id
	const log = useLog(function_id)

	const logpath = props.logpath

	const globalErrorContext = useContext(GlobalErrorContext)
	const userContext = useContext(UserContext)
	// const swapbotContext = useContext(SwapBotContext)

	const [hasUpdatedEmptyWalletName, set_hasUpdatedEmptyWalletName] = useState(false)
	const [hasCalledFirstLoading, set_hasCalledFirstLoading] = useState(false)

	// Use refs properly
	/* note: When setTimeout is scheduled it's using the value of count at the time it was scheduled.
		It's relying on a closure to access count asynchronously.
		When the component re-renders a new closure is created but that doesn't change the value that was initially closed over.
		In this case you need to use a "container" that you can write the updated state value to, and read later on the timeout.
		This is one use case for useRef.
		You can sync the state value with the ref's current property and read current in the timeout instead.
		cf https://github.com/facebook/react/issues/14010  	*/
	// Use a ref to access the current count value in an async callback
	const userContextRef = useRef(userContext)
	const ref_waiting_reload_after_finish = useRef(false);

	// Handle initial wallet name update
	useEffect(() => {
		if (userContext.walletname.length === 0 && !hasUpdatedEmptyWalletName) {
			set_hasUpdatedEmptyWalletName(true);
			userContext.update_wallet_name("unnamed wallet");
		}
	}, [userContext.walletname, hasUpdatedEmptyWalletName]);

	// Handle first loading
	// Fire reload_wallet() immediately on first mount — no artificial delay.
	// (Used to be wrapped in a 700ms setTimeout, which just slowed down startup.)
	// BUT: if we're awaiting unlock (encrypted blob found but not yet decrypted),
	// don't fire reload_wallet — the wallet can't load without privkeys.
	useEffect(() => {
		if (!hasCalledFirstLoading && !userContext.awaiting_unlock) {
			set_hasCalledFirstLoading(true);
			userContext.reload_wallet();
		}
	}, [hasCalledFirstLoading, userContext.awaiting_unlock]);

	// Sync ref with current userContext
	useEffect(() => {
		userContextRef.current = userContext;
	}, [userContext]);

	/**
	 * because reload_wallet is debounced, we need to wait for wallet to have loaded
	 * to start a new reload
	 * 
	 * @param {*} is_original_caller don't provide this it's only for internal use
	 * @returns nothing
	 */
	const reload_wallet_after_finish = (is_original_caller = false) => {
		const function_id = "reload_wallet_after_finish(): "
		const log = getLog(function_id)
		const waiting_reload_wallet_after_finish = ref_waiting_reload_after_finish.current

		if (!is_original_caller) {
			log("called, waiting_reload_wallet_after_finish=", waiting_reload_wallet_after_finish)
			// we only need to reload once, even if we asked multiple times while waiting
			if (waiting_reload_wallet_after_finish) return
			log("taking lock")
			ref_waiting_reload_after_finish.current = true
		}

		const currentUserContext = userContextRef.current
		log("currentUserContext.isloading=", currentUserContext.isloading)
		if (!currentUserContext.isloading) {
			log("reloading wallet and freeing lock")
			// free the lock
			ref_waiting_reload_after_finish.current = false
			currentUserContext.reload_wallet()
		} else {  // loop after a delay
			setTimeout(() => {
				reload_wallet_after_finish(true)
			}, 1000)
		}
	}

	let globalError_jsx = null
	if (globalErrorContext.globalError) {
		const isNetworkError = isNetworkErrorString(globalErrorContext.globalError)
		globalError_jsx = <WithPopup
			forceShow={true}
			buttonText={isNetworkError ? "Retry" : "Continue"}
			popupcontent={translateErrorToJSXMessage(globalErrorContext.globalError)}
			closePopupCallback={isNetworkError
				? () => { userContext.resetGlobalError(); reload_wallet_after_finish() }
				: userContext.resetGlobalError
			}
		/>
	} else if (globalErrorContext.needAutoReload) {
		log("detected globalErrorContext.needAutoReload")
		globalErrorContext.set_needAutoReload(false)
		// necessary bc we hide errors like "location not found"
		reload_wallet_after_finish()
	}

	// If we're awaiting unlock, redirect to the unlock screen instead of
	// trying to render the wallet (which would fail without privkeys).
	if (userContext.awaiting_unlock) {
		return <Redirect to={route_wallet_unlock} push />
	}

	let backgroundColor = appConfig.theme.backgroundColorDarker1

	const history = useHistory()

	// The `:token_id` URL path param is the source of truth for the active token;
	// useTokenOrigin() keeps UserContext.selected_coin in sync with it.
	useTokenOrigin()

	const { width: windowWidth = 0 } = useWindowSize(); // fallback
	const isMobile = windowWidth < Constants.WINDOW_WIDTH_THRESHOLD_PX

	return (
		<div className="display_wallet" style={{ height: "100%" }}>
			{/* <SyncBlockchainPopup />  // deprecated*/}

			{/* Slide header */}
			<div id="wallet_show_home" style={{ marginLeft: "15px" }}>
				{/* onClick={() => { TODO load main slide here }}> */}
				<h4 style={{ margin: "7px" }}>
					{/* Accueil */}
				</h4>
			</div>

			{/* <div id="debug" style={{color:"white",overflow:"auto"}} /> // debug console */}

			{/* Tab navigation system */}
			<div id="container">
				<DetectConvertTokens />
				{isMobile ? null :
					<MenuPanelOptions />
				}

				<div id="content" >
					{globalError_jsx}
					<Switch>

					<Route exact path='/'
						render={() => <Slide_WalletHome />}
					/>
					<Route exact path='/wallet'
						render={() => <Slide_WalletHome />}
					/>

					{/* Static path must precede /wallet/:token_id so it isn't shadowed
					    by the parametrized route (Switch renders first match). */}
					<Route exact path="/wallet/settings" render={() =>
						// TODO handle  onClickedReportBug
						// <Slide_ReportBug num="15" logpath={logpath} />
						<Slide_Settings logpath={logpath} onClickedReportBug={() => { clicked_menu_item("15") }} />
					} />

					<Route exact path="/wallet/:token_id" render={() => <Slide_Balance />} />
					<Route exact path="/wallet/:token_id/balance" render={() => <Slide_Balance />} />
					<Route exact path="/wallet/:token_id/mintuples" render={() => <Slide_Multiplicators />} />
					<Route exact path="/wallet/:token_id/history" render={() => <Slide_History />} />
					<Route exact path="/wallet/:token_id/send" render={() => <Slide_Send />} />
					<Route exact path="/wallet/:token_id/swap" render={() => <Slide_EchangeTokens_QR />} />

						<Route exact path="/wallet/:token_id/admin/mint" render={() => <Slide_MintTokens />} />
						<Route exact path="/wallet/:token_id/admin/mintuples" render={() => <Slide_PublishMultiplicator />} />
						<Route exact path="/wallet/:token_id/admin/global-burn" render={() => <Slide_GlobalBurn />} />
						<Route exact path="/wallet/:token_id/admin/burn" render={() => <Slide_Burn />} />
						<Route exact path="/wallet/:token_id/admin/revoke-backup" render={() => <Slide_AllRevoke />} />
						<Route exact path="/wallet/:token_id/admin/create-contracts" render={() => <Slide_TokkenR />} />
						<Route exact path="/wallet/:token_id/admin/swaps" render={() => <Slide_SwapBot />} />
						
						{/* // deprecated
							// <Slide_EchangeTokens_SwapBot />
							// <Slide_SwapBot />
							// <Slide_Explorer />
							// <Slide_Account /> 
	 					*/}
					</Switch>
				</div>
			</div>
		</div>
	)
}

export default Display_Wallet
